module.exports = __WEBPACK_EXTERNAL_MODULE__9560__;